import wcTitleBg from 'assets/images/wc2026/wc_title_bg.png';

const intro =
  'Dự đoán đội vô địch World Cup 2026: Từ 01/06/2026 00:00:00 đến 11/06/2026 23:59:59, hội viên chọn 1 đội duy nhất trong danh sách các đội tuyển chính thức tham dự; kết quả lấy theo đội thắng trận chung kết do FIFA công bố (bao gồm hiệp phụ và loạt sút luân lưu).';

const conditions = [
  'Sau khi có kết quả chính thức, hệ thống sẽ tự động kiểm tra và phát thưởng vào tài khoản hội viên trong vòng 24 giờ. Thành viên đăng nhập tài khoản bấm vào【Nhận thưởng】Bấm chọn【nhận】để nhận thưởng.',
  'Áp dụng cho hội viên hợp lệ có tổng nạp từ ngày hôm trước đến thời điểm dự đoán ≥ 300 điểm trước khi dự đoán.',
  'Mỗi một tài khoản, mỗi một IP, thiết bị đăng nhập, thẻ ngân hàng, Email và SĐT chỉ được dự đoán 1 lần/1 trận đấu. Dự đoán hợp lệ là dự đoán được gửi đúng thời gian quy định.',
  'Thành viên lạm dụng, vi phạm quy định công ty sẽ không được tham gia khuyến mãi này.',
  'Hi88 bảo lưu quyền thay đổi, dừng hoặc hủy bỏ chương trình khuyến mãi này bất cứ lúc nào.'
];

const rewardRows = [
  { vip: 'VIP0 - VIP2', reward: '28' },
  { vip: 'VIP3 - VIP10', reward: '88' },
  { vip: 'VIP11 - VIP15', reward: '188' },
  { vip: 'VIP16 - VIP20', reward: '288' },
  { vip: 'VIP21 - VIP30', reward: '388' },
  { vip: 'VIP31 - VIP50', reward: '588' },
  { vip: 'VIP51 - VIP60', reward: '888' }
];

const Rule = () => {
  return (
    <div
      className="relative flex w-full flex-col items-stretch gap-4 self-stretch rounded-[40px] bg-gradient-to-b from-[#d7f4ff] to-[#e3f2f8] px-5 pb-8 pt-[52px] md:gap-4 md:px-10 md:pb-10 md:pt-14"
      role="region"
      aria-labelledby="rule-title"
    >
      <div className="pointer-events-none absolute left-1/2 top-1.5 z-10 w-full max-w-[366px] -translate-x-1/2 -translate-y-[42%] px-2 md:-translate-y-[38%]">
        <div className="relative mx-auto h-[44px] w-full max-w-[280px] md:h-[47px] md:max-w-[366px]">
          <img src={wcTitleBg} alt="" className="h-full w-full object-contain" draggable={false} />
          <div
            id="rule-title"
            className="absolute inset-0 z-10 grid place-items-center px-6 text-center text-[18px] font-black uppercase leading-tight text-white drop-shadow-[0_3px_4px_rgba(0,20,42,0.5)] md:text-2xl"
          >
            Thể lệ
          </div>
        </div>
      </div>

      {/* <p className="mt-1 text-left font-sans text-base font-normal leading-[1.5] text-[#191919]">
        {intro}
      </p> */}

      <div className="flex flex-col gap-3">
        <div className="relative h-[37px] w-full overflow-hidden rounded-sm">
          <div
            className="absolute inset-0 bg-gradient-to-b from-[#26A9E0] to-[#0B85C7]"
            aria-hidden
          />
          <div className="absolute bottom-0 left-0 right-0 h-px bg-[#0D88C9]" aria-hidden />
          <span className="relative z-10 flex h-full items-center justify-center px-4 font-sans text-lg font-bold uppercase leading-tight text-white">
            Phần thưởng
          </span>
        </div>

        <div className="rounded-2xl bg-transparent">
          <table className="w-full table-fixed border-separate border-spacing-[2px] text-center text-[#2f9ed0] md:border-spacing-[3px]">
            <thead>
              <tr className="text-[12px] leading-snug md:text-[18px] md:leading-normal">
                <th className="rounded-[10px] bg-gradient-to-b from-[#33afe6] to-[#299acb] px-1.5 py-1.5 font-bold text-white shadow-[0_1px_2px_rgba(0,0,0,0.1)] md:px-3 md:py-2 break-words">
                  Cấp độ VIP
                </th>
                <th className="rounded-[10px] bg-gradient-to-b from-[#33afe6] to-[#299acb] px-1.5 py-1.5 font-bold text-white shadow-[0_1px_2px_rgba(0,0,0,0.1)] md:px-3 md:py-2 break-words">
                  Tiền thưởng
                </th>
                <th className="rounded-[10px] bg-gradient-to-b from-[#33afe6] to-[#299acb] px-1.5 py-1.5 font-bold text-white shadow-[0_1px_2px_rgba(0,0,0,0.1)] md:px-3 md:py-2 break-words">
                  Vòng cược
                </th>
              </tr>
            </thead>
            <tbody>
              {rewardRows.map((row, idx) => (
                <tr
                  key={row.vip}
                  className="text-[12px] leading-snug md:text-[16px] md:leading-tight"
                >
                  <td className="rounded-[10px] bg-[#eef4f2] px-1.5 py-1.5 font-bold break-words md:px-3 md:py-2">
                    {row.vip}
                  </td>
                  <td className="rounded-[10px] bg-[#eef4f2] px-1.5 py-1.5 font-bold md:px-3 md:py-2">
                    {row.reward}
                  </td>
                  {idx === 0 ? (
                    <td
                      className="rounded-[10px] bg-[#eef4f2] px-1.5 py-1.5 align-middle text-[12px] font-bold break-words md:px-3 md:py-2 md:text-[16px]"
                      rowSpan={rewardRows.length}
                    >
                      1 Vòng cược
                    </td>
                  ) : null}
                </tr>
              ))}
              <tr className="text-[12px] leading-snug md:text-[16px] md:leading-tight">
                <td
                  className="rounded-[10px] bg-[#eef4f2] px-1.5 py-1.5 font-semibold break-words md:px-3 md:py-2"
                  colSpan={3}
                >
                  Áp dụng cho tài khoản ngày hôm trước có tổng nạp ≥ 300 điểm
                </td>
              </tr>
              <tr className="text-[12px] leading-snug md:text-[16px] md:leading-tight">
                <td
                  className="rounded-[10px] bg-[#eef4f2] px-1.5 py-1.5 font-semibold break-words md:px-3 md:py-2"
                  colSpan={3}
                >
                  Dự đoán đội vô địch, vua phá lưới, cầu thủ xuất sắc nhất sẽ nhận thưởng thêm ...
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <div className="relative h-[37px] w-full overflow-hidden rounded-sm">
          <div
            className="absolute inset-0 bg-gradient-to-b from-[#26A9E0] to-[#0B85C7]"
            aria-hidden
          />
          <div className="absolute bottom-0 left-0 right-0 h-px bg-[#0D88C9]" aria-hidden />
          <span className="relative z-10 flex h-full items-center justify-center px-4 font-sans text-lg font-bold uppercase leading-tight text-white">
            Điều kiện khuyến mãi
          </span>
        </div>

        <div className="flex flex-col gap-2">
          {conditions.map((text, i) => (
            <p
              key={i}
              className="text-left font-sans text-base font-normal leading-[1.5] text-[#191919]"
            >
              {text}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Rule;
